<template>
  <div class="salesman-form-material">
    <Form ref="form" :model="formData" class="page-form" label-position="top">
      <FormItem label="身份证正面" prop="idCardFront">
        <Uploadingcertificate v-model="formData.idCardFront">
          <img src="@static/images/card-empty1.png">
        </Uploadingcertificate>
        <p class="info-text">注释:仅限上传jpg/jpeg/png格式；</p>
      </FormItem>
      <FormItem label="身份证反面" prop="idCardReverse">
        <Uploadingcertificate v-model="formData.idCardReverse">
          <img src="@static/images/card-empty2.png">
        </Uploadingcertificate>
        <p class="info-text">注释:仅限上传jpg/jpeg/png格式；</p>
      </FormItem>
      <FormItem label="白底登记照（半身）" prop="registrationLicense">
        <Uploadingcertificate v-model="formData.registrationLicense">
          <i class="empty-icon iconfont icondengjizhao"></i>
        </Uploadingcertificate>
        <p class="info-text">注释:仅限上传jpg/jpeg/png格式；</p>
      </FormItem>
      <FormItem label="手持身份证">
        <Uploadingcertificate v-model="formData.handIdCard">
          <i class="empty-icon iconfont iconshouchishenfenzheng"></i>
        </Uploadingcertificate>
        <p class="info-text">注释:仅限上传jpg/jpeg/png格式；</p>
      </FormItem>
      <br>
      <FormItem label="银行卡" class="full">
        <div class="list">
          <Uploadingcertificate v-for="(value, i) in formData.bankPicList" :key="i" :value="value" previewId="bankPicList"
            @input="changeImg($event, 'bankPicList', i)">
            <i class="empty-icon iconfont iconyinhangka"></i>
          </Uploadingcertificate>
        </div>
        <p class="info-text">注释:仅限上传jpg/jpeg/png格式；</p>
      </FormItem>
      <br>
      <FormItem label="面试记录表" class="full">
        <div class="list">
          <Uploadingcertificate v-for="(value, i) in formData.interviewList" :key="i" :value="value"
            previewId="interviewList" @input="changeImg($event, 'interviewList', i)" type="png|jpg|pdf">
            <i class="empty-icon iconfont iconmianshijilubiao"></i>
          </Uploadingcertificate>
        </div>
        <p class="info-text">注释:仅限上传jpg/jpeg/png/pdf格式；</p>
      </FormItem>
      <br>
      <FormItem label="工作证明" class="full">
        <div class="list">
          <Uploadingcertificate v-for="(value, i) in formData.workCertificateList" :key="i" :value="value"
            previewId="workCertificateList" @input="changeImg($event, 'workCertificateList', i)" type="png|jpg|pdf">
            <i class="empty-icon iconfont icongongzuozhengming"></i>
          </Uploadingcertificate>
        </div>
        <p class="info-text">注释:仅限上传jpg/jpeg/png/pdf格式；</p>
      </FormItem>
      <br>
      <FormItem label="学历证信息" class="full">
        <div class="list">
          <Uploadingcertificate v-for="(value, i) in formData.diplomaList" :key="i" :value="value" previewId="diplomaList"
            @input="changeImg($event, 'diplomaList', i)" type="png|jpg|pdf">
            <i class="empty-icon iconfont iconbiyexinxi"></i>
          </Uploadingcertificate>
        </div>
        <p class="info-text">注释:仅限上传jpg/jpeg/png/pdf格式；</p>
      </FormItem>
      <br>
      <br>
      <FormItem label="其他资料" class="full">
        <div class="list">
          <Uploadingcertificate v-for="(value, i) in formData.otherInfoList" :key="i" :value="value"
            previewId="otherInfoList" @input="changeImg($event, 'otherInfoList', i)" type="png|jpg|pdf">
            <i class="empty-icon iconfont iconqitaziliao"></i>
          </Uploadingcertificate>
        </div>
        <p class="info-text">注释:仅限上传jpg/jpeg/png/pdf格式；</p>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import Uploadingcertificate from "@/components/commons/Uploadingcertificate";
export default {
  components: { Uploadingcertificate },
  props: {},
  data() {
    return {
      indoorStaffId: "",
      fileKeys: ['bankPicList', 'interviewList', 'diplomaList', 'otherInfoList', 'workCertificateList'],
      formData: {
        registrationLicense: "",//手持身份证
        idCardFront: "",//身份证正面
        idCardReverse: "",//身份证反面
        interview: "",//面试记录
        practiceList: [""],//执业证
        bankPicList: [""],//银行卡
        interviewList: [""],//面试记录表
        workCertificateList: [""],//工作证明
        diplomaList: [""],//毕业证信息        
        otherInfoList: [""],//其他资料
      }
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.indoorStaffId = this.$route.query.indoorStaffId;
  },
  methods: {
    save() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then(isok => {
          if (!isok) {
            reject({ page: 'material', showMsg: true })
            return;
          }
          const formData = JSON.parse(JSON.stringify(this.formData));
          // 去掉占位的空数据
          this.fileKeys.forEach(key => {
            const fileList = formData[key];
            const lastIndex = fileList.length - 1;
            if (fileList[lastIndex] == "") {
              fileList.splice(lastIndex, 1)
            }
          })
          if (formData.practiceList) {
            formData.practiceList = formData.practiceList.slice(0, 1)
          } else {
            formData.practiceList = [""];
          }
          formData.indoorStaffId = this.indoorStaffId;
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.$http({
            type: "POST",
            url: "/buz/userCertificate/add",
            data: formData
          }).then(res => {
            this.loading = false;
            resolve();
          }).catch(res => {
            this.loading = false;
            reject({ page: 'material', showMsg: true })
          });
        }).catch(res => {
          reject({ page: 'material' })
        })
      })
    },
    setData() {
      this.getData();
    },
    getData() {
      if (!this.indoorStaffId) {
        return;
      }
      this.$http({
        url: "/buz/userCertificate/getByUserId",
        type: "get",
        data: {
          indoorStaffId: this.indoorStaffId
        },
      }).then((res) => {
        this.visible = true;
        const data = res.data;
        if (!data) {
          return;
        }
        // 末尾不是空时补上占位的空字符串
        this.fileKeys.forEach(key => {
          const fileList = data[key];
          if (!fileList) {
            data[key] = [""];
          } else if (fileList[fileList.length - 1] != "") {
            fileList.push("");
          }
        })
        this.formData = data
      });
    },
    changeImg(data, type, i) {
      if (data) {//新增
        if (this.formData[type].length - 1 == i && type != 'practiceList') {
          this.formData[type].push("")
        }
        this.$set(this.formData[type], i, data)
      } else {//删除
        if (type == 'practiceList') {
          this.formData[type] = [""]
        } else {
          this.formData[type].splice(i, 1);
        }

      }
    },
  },
};
</script>
<style lang="scss" scoped>
.salesman-form-material {
  .ivu-form-item {
    .info-text {
      font-size: 12px;
      line-height: 1.5;
      padding-top: 5px;
      color: #a9a9a9;
    }

    width: 312px;

    &.full {
      width: 100%;
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -15px;

    .upload-item {
      margin-right: 50px;
      margin-bottom: 15px;
    }
  }
}
</style>